

import { Component,inject, signal, } from '@angular/core';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { PlatformService } from '../platform-service';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { GetActiveSessionResponseDto } from '../launch-tool/dtos/get-active-session.response.dto';
import { FieldsetModule } from 'primeng/fieldset';
import { GetContentItemsResponseDto } from '../deeplink/dtos/get-content-items.response.dto';
import { LessonsToolsMappingService } from '../deeplink/services/lessons-tools-mapping.service';
import { TargetLinkURICustomizationService } from '../deeplink/services/target-link-uri-customization.service';
import { MessageModule } from 'primeng/message';


@Component({
  selector: 'app-debug',
  standalone: true,
  imports: [RouterModule,CardModule,ButtonModule,FieldsetModule,MessageModule],
  templateUrl: './debug.html',
  styleUrls: ['./debug.css'],
  providers:[LessonsToolsMappingService,TargetLinkURICustomizationService]
})
export class DebugComponent {
  items: any[] = [];
  private router = inject(Router);
  contentItems = signal<GetContentItemsResponseDto[]>([])
  constructor(
    private route : ActivatedRoute,
    private platformService:PlatformService,
    private shellCoursesToolsMappingService:LessonsToolsMappingService,
    private targetLinkURICustomizationService:TargetLinkURICustomizationService
  ){}
   ngOnInit(): void {
     
    }
  async initiateCourseLaunchWithoutDeeplinking(){
      // const targetLinkURI = await this.targetLinkURICustomizationService.getTargetLinkURIAsPerToolMappedTo(courseCode,contentItems);
      //     const userInfo: GetActiveSessionDto = {
      //     "id": "1",
      //     "userId": "aaa",
      //     "courseCode": courseCode,
      //     "firstName": "Siddharth",
      //     "lastName": "Roy",
      //     "email": "sroychoudhury@relias.de",
      //     "createdAt": new Date(),
      //     "refreshedAt": new Date(),
      //     "targetLinkURI":"TBD"
      // }
      // this.platformService.initiateCourseLibraryLaunch("REL-DE-LTI-66062",userInfo)
  }
   async initiateCourseLaunchWithDeeplinking(courseCode:string){
       // need to think here how to setup debug 
          // most likely show a drop down for course code selection
          // then based on selection of course code and course <> contentItems mapping ( 1 or more)
          // show link and let click on each link create its own targetLinkUri 
      // const contentItems = await this.shellCoursesToolsMappingService.getContentItemsForShellCourse(courseCode);
      // const targetLinkURI = await this.targetLinkURICustomizationService.getTargetLinkURIAsPerToolMappedTo(courseCode,contentItems);
      //     const userInfo: GetActiveSessionDto = {
      //     "id": "1",
      //     "userId": "aaa",
      //     "courseCode": courseCode,
      //     "firstName": "Siddharth",
      //     "lastName": "Roy",
      //     "email": "sroychoudhury@relias.de",
      //     "createdAt": new Date(),
      //     "refreshedAt": new Date(),
      //     "targetLinkURI":"TBD"
      // }
      // this.platformService.initiateCourseLibraryLaunch("REL-DE-LTI-66062",userInfo)
  }
  showAlert(msg:string){
    alert(msg)
  }
}

